import PdaTitle from '../../../component/common/PdaTitle'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { MidmileIncomingData, MidmileIncomingSearch } from '../../../types/inbound'
import { CommonContext } from '../../../component/common/context/commonContext'
import { ScrollPanel } from 'primereact/scrollpanel'
import { getContentSize } from '../../../utils/screenUtils'
import { classNames } from 'primereact/utils'
import { useMountEffect } from 'primereact/hooks'
import { Button } from 'primereact/button'
import { debounce, isEmpty, size } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const MidmileIncoming = () => {
    const { $http, $alert, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const scanRef = useRef<HTMLInputElement | null>(null)
    const [mdlmlPltNo, setMdlMlPltNo] = useState<string>('')
    const [buttonLabel, setButtonLabel] = useState<string>('')
    const [height, setHieght] = useState<number>(getContentSize())
    const [disabledButton, setDisabledButton] = useState<boolean>(false)
    const [incomings, setIncomings] = useState<MidmileIncomingData[]>()
    const [params, setParams] = useState<MidmileIncomingSearch>({
        mdlmlPltNo: '',
    })

    useMountEffect(() => {
        setTimeout(() => {
            if (scanRef && scanRef.current) {
                scanRef.current.focus()
            }
        }, 300)
    })

    const findMidmileIncoming = useCallback(
        async (params: MidmileIncomingSearch) => {
            const result = await $http().get('/inbound/midmile-incoming', {
                params: { ...params },
            })
            console.log(result)
            if (isEmpty(result)) {
                setMdlMlPltNo('')
                if (scanRef && scanRef.current) {
                    scanRef.current?.focus()
                }
                return
            }

            const isComplete = result[0].mdlmlInbSttCd === 'IC'
            setDisabledButton(false)
            setButtonLabel(
                isComplete
                    ? `${t(tokens.inbound.complete_midlmile_inbound)} ${findCount(result)}`
                    : `${t(tokens.inbound.processing_complete_midlmile_inbound)} ${findCount(result)}`,
            )
            setIncomings(result)
            setTimeout(() => setHieght(getContentSize()), 300)
            setMdlMlPltNo('')
            if (scanRef && scanRef.current) {
                scanRef.current?.focus()
            }
        },
        [$http],
    )

    useEffect(() => {
        if (params.mdlmlPltNo) {
            findMidmileIncoming(params)
        }
    }, [params, findMidmileIncoming])

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            setParams({
                ...params,
                mdlmlPltNo,
            })
        }
    }

    const getCardStyle = (scanYn: string) => {
        if (scanYn) {
            return {
                background: '#90EE90',
                border: '1px solid #D3D3D3',
            }
        } else {
            return {
                background: '#F8F9FA',
                border: '1px solid #D3D3D3',
                color: 'black',
            }
        }
    }

    const findCount = (result: any) => {
        if (isEmpty(result)) {
            return ''
        }

        const total = size(result)
        const scanCount = size(result?.filter((incoming: any) => incoming.inbScanYn === 'Y'))

        return `(${scanCount} / ${total})`
    }

    const onClickMidmileComplete = debounce(async () => {
        if (!incomings || isEmpty(incomings)) {
            return
        }

        const isNotMatched = size(incomings) !== size(incomings?.filter((incoming) => incoming.inbScanYn === 'Y'))

        if (isNotMatched) {
            const isConfirm = await $alert({
                icon: 'info',
                title: t(tokens.inbound.incoming_confirmation),
                text: t(tokens.inbound.less_then_expted_midlmile_plt_quantity),
                isConfirm: true,
            })

            if (!isConfirm) {
                return
            }
        }

        const mdlmlId = incomings[0].mdlmlId

        const result = await $http().put('/inbound/midmile-incoming', {
            mdlmlId,
            isNotMatched,
        })

        if (result) {
            $toast({ title: t(tokens.common.success), text: `간선 입고가 완료 되었습니다.`, icon: 'success' })
            setIncomings([])
        }
    }, 1000)

    const findStatusColor = (inbScanYn: string) => {
        return { color: inbScanYn === 'Y' ? '#2E8B57' : 'red' }
    }

    return (
        <>
            <PdaTitle title={t(tokens.inbound.midmile)} historyBack goToHome />
            <div className="grid pda-search p-3">
                <div className="col-12 flex">
                    <InputText
                        ref={scanRef}
                        value={mdlmlPltNo}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.inbound.please_scan_midmile_incoming_label_barcode)}
                        onChange={(e) => setMdlMlPltNo(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                        inputMode="none"
                        autoFocus={true}
                    />
                </div>
            </div>
            <div className="grid pl-2">
                {incomings && !isEmpty(incomings) ? (
                    <ScrollPanel className="flex w-full p-1" style={{ height: height }}>
                        {incomings.map((incoming) => (
                            <div className="mt-1" key={incoming.mdlmlPltNo}>
                                <div className="card w-full p-2" style={getCardStyle(incoming.inbScanYn)}>
                                    <div className="col-12 flex py-0 font-bold text-lg">
                                        <div className={classNames('col-3 text-left rdms-text-deepblue')}>출/도착지</div>
                                        <div className="col-6 align-self-center text-left">
                                            {incoming.dprCenterNm} / {incoming.arvCenterNm}
                                        </div>
                                        <div className="col-3 text-right">
                                            {incoming.pltNo} / {incoming.lblQty}
                                        </div>
                                    </div>
                                    <div className="col-12 justify-content-between flex py-0 align-items-center">
                                        <div className={classNames('col-3 text-left font-bold text-lg rdms-text-deepblue')}>
                                            t(tokens.inbound.date_time)
                                        </div>
                                        <div className="col-6 text-left text-overflow-ellipsis overflow-hidden white-space-nowrap text-lg">
                                            {incoming.scanYmdhmFm ? incoming.scanYmdhmFm : '-'}
                                        </div>
                                        <div className="col-3 text-right font-bold" style={findStatusColor(incoming.inbScanYn)}>
                                            {incoming.inbScanYn === 'Y' ? t(tokens.inbound.complete) : t(tokens.inbound.incoming_waiting)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ScrollPanel>
                ) : (
                    <div className="font-bold text-center w-full vertical-align-middle" style={{ paddingTop: height / 3 }}>
                        {t(tokens.inbound.please_scan_midmile_incoming_label_barcode)}
                    </div>
                )}
            </div>
            <div
                className={classNames('pda-bottom', { 'display-none': isEmpty(incomings) })}
                style={{ position: 'absolute', bottom: 0, width: '100%', zIndex: 100 }}
            >
                <Button
                    label={buttonLabel}
                    size="large"
                    className="w-full p-button-info border-none"
                    onClick={onClickMidmileComplete}
                    disabled={disabledButton}
                />
            </div>
        </>
    )
}

export default MidmileIncoming
